import {Injectable} from '@angular/core';
import {AbstractModelService} from "../../model/abstract-model.service";
import {ApiClientService} from "../../api-client/api-client.service";
import {ActivityComment} from '../../../models/crm/activity-comment';

@Injectable({
  providedIn: 'root'
})
export class ActivityCommentService extends AbstractModelService<ActivityComment> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/crm/activity-comment', ActivityComment);
  }
}
